export const LINK_CREATE_RESET = "LINK_CREATE_RESET";
export const LINK_CREATE_SET_CREATED = "LINK_CREATE_SET_CREATED";
export const LINK_CREATE_SET_ERROR = "LINK_CREATE_SET_ERROR";
export const LINK_CREATE_SET_VIOLATIONS = "LINK_CREATE_SET_VIOLATIONS";
export const LINK_CREATE_TOGGLE_LOADING = "LINK_CREATE_TOGGLE_LOADING";
